import {
  BarcodeType,
  DomainObjectPropertyType,
  LabelObjectOrientation,
  LabelObjectPlainTextPosition,
  LabelTemplateDestinationType,
  LabelTemplateDPIResolution,
  LabelTemplateObjectAlignmentType,
  LabelTemplateObjectType,
  LabelTemplateTextFont,
  LabelTemplateTextType,
} from "@/api/classes/labelTemplate/labelTemplate.dto";
import type { BaseProductDto } from "@/types/product/productTypes";
import type { PartnerDto } from "@/api/api.dto";

export const LabelTemplateDestinationTypeTranslation: Record<
  LabelTemplateDestinationType,
  string
> = {
  [LabelTemplateDestinationType.ProductItemFBM]: "Товар FBM",
  [LabelTemplateDestinationType.Box]: "Короб",
  [LabelTemplateDestinationType.Supply]: "Поставка",
  [LabelTemplateDestinationType.ProductItemWbFBS]: "Товар FBS WB",
  [LabelTemplateDestinationType.ProductItemOzonFBS]: "Товар FBS Ozon",
};

export const LabelTemplateDPIResolutionTranslation: Record<
  LabelTemplateDPIResolution,
  string
> = {
  [LabelTemplateDPIResolution.ThreeHundred]: "300 DPI",
  [LabelTemplateDPIResolution.TwoHundredAndThree]: "203 DPI",
};

export const LabelTemplateObjectTypeTranslation: Record<
  LabelTemplateObjectType,
  string
> = {
  [LabelTemplateObjectType.Text]: "Текст",
  [LabelTemplateObjectType.Barcode]: "Штрихкод товара",
  [LabelTemplateObjectType.CurrentDateAndTimeOfTheUserMachine]:
    "Текущая дата и время",
  [LabelTemplateObjectType.SupplyBarcode]: "QR код поставки FBS WB",
  [LabelTemplateObjectType.BoxBarcode]: "QR код короба WB для ПВЗ",
  [LabelTemplateObjectType.FbsWBBarcode]: "QR код заказа FBS WB",
  [LabelTemplateObjectType.Logo]: "Логотип",
  [LabelTemplateObjectType.FbsOzonBarcode]: "Этикетка FBS Ozon",
};

export const LabelTemplateObjectAlignmentTypeTranslation: Record<
  LabelTemplateObjectAlignmentType,
  string
> = {
  [LabelTemplateObjectAlignmentType.Left]: "По левому краю",
  [LabelTemplateObjectAlignmentType.Right]: "По правому краю",
  [LabelTemplateObjectAlignmentType.Centered]: "По центру",
};

export const LabelTemplateTextTypeTranslation: Record<
  LabelTemplateTextType,
  string
> = {
  [LabelTemplateTextType.PlainText]: "Обычный текст",
  [LabelTemplateTextType.DomainObjectProperty]: "Свойство объекта",
};

export const LabelTemplateBarcodeTypeTranslation: Record<BarcodeType, string> =
  {
    [BarcodeType.EAN13]: "EAN13",
    [BarcodeType.EAN8]: "EAN8",
    [BarcodeType.CODE128]: "CODE128",
    [BarcodeType.QRCode]: "QRCode",
    [BarcodeType.DataMatrix]: "DataMatrix",
    [BarcodeType.GS1DataMatrix]: "GS1DataMatrix",
  };

export const LabelObjectOrientationTranslations: Record<
  LabelObjectOrientation,
  string
> = {
  [LabelObjectOrientation.Horizontal]: "Горизонтально",
  [LabelObjectOrientation.UpDown]: "Сверху вниз",
  [LabelObjectOrientation.DownUp]: "Снизу вверх",
};

export const LabelObjectPlainTextPositionTranslations: Record<
  LabelObjectPlainTextPosition,
  string
> = {
  [LabelObjectPlainTextPosition.Left]: "Слева",
  [LabelObjectPlainTextPosition.Right]: "Справа",
};

export const LabelTemplateTextFontTranslations: Record<
  LabelTemplateTextFont,
  string
> = {
  [LabelTemplateTextFont.ARIAL]: "Arial",
  [LabelTemplateTextFont.HELVETICA]: "Helvetica",
  [LabelTemplateTextFont.VERDANA]: "Verdana",
  [LabelTemplateTextFont.TAHOMA]: "Tahoma",
  [LabelTemplateTextFont.COURIER_NEW]: "Courier New",
  [LabelTemplateTextFont.TIMES_NEW_ROMAN]: "Times New Roman",
};

export const DomainObjectPropertyTypeTranslation: Record<
  DomainObjectPropertyType,
  string
> = {
  [DomainObjectPropertyType.ProductName]: "Название товара",
  [DomainObjectPropertyType.ProductBarcode]: "Штрихкод товара",
  [DomainObjectPropertyType.ProductBrand]: "Бренд товара",
  [DomainObjectPropertyType.ProductOzonArticle]: "Артикул Ozon",
  [DomainObjectPropertyType.ProductWildberriesArticle]: "Артикул Wildberries",
  [DomainObjectPropertyType.Organization]: "Организация",
  [DomainObjectPropertyType.ManufacturersName]: "Имя производителя",
  [DomainObjectPropertyType.ManufacturersINN]: "ИНН производителя",
  [DomainObjectPropertyType.ManufacturersAddress]: "Адрес производителя",
  [DomainObjectPropertyType.ManufacturersCountry]: "Страна производителя",
  [DomainObjectPropertyType.ProductColor]: "Цвет товара",
  [DomainObjectPropertyType.ProductSize]: "Размер товара",
  [DomainObjectPropertyType.ManufacturersSize]: "Размер производителя",
  [DomainObjectPropertyType.ProductComposition]: "Состав товара",
  [DomainObjectPropertyType.CareOfThings]: "Уход за вещами",
  [DomainObjectPropertyType.ProductShelfLife]: "Срок годности товара",
  [DomainObjectPropertyType.TNVED]: "ТН ВЭД",
};

export const PartnerKeyByDomainObjectPropertyType: Partial<
  Record<DomainObjectPropertyType, keyof PartnerDto>
> = {
  [DomainObjectPropertyType.Organization]: "organization",
  [DomainObjectPropertyType.ManufacturersName]: "name",
  [DomainObjectPropertyType.ManufacturersINN]: "inn",
};

export const orderTypeByDomainObjectPropertyType: Partial<
  Record<DomainObjectPropertyType, "partner" | "product">
> = {
  [DomainObjectPropertyType.ProductName]: "product",
  [DomainObjectPropertyType.ProductBarcode]: "product",
  [DomainObjectPropertyType.ProductBrand]: "product",
  [DomainObjectPropertyType.ProductOzonArticle]: "product",
  [DomainObjectPropertyType.ProductWildberriesArticle]: "product",
  [DomainObjectPropertyType.Organization]: "partner",
  [DomainObjectPropertyType.ManufacturersName]: "partner",
  [DomainObjectPropertyType.ManufacturersINN]: "partner",
  [DomainObjectPropertyType.ProductSize]: "product",
  [DomainObjectPropertyType.ManufacturersSize]: "product",
};

export const BaseProductKeyByDomainObjectPropertyType: Partial<
  Record<DomainObjectPropertyType, keyof BaseProductDto>
> = {
  [DomainObjectPropertyType.ProductName]: "title",
  [DomainObjectPropertyType.ProductBarcode]: "barcode",
  [DomainObjectPropertyType.ProductBrand]: "brand",
  [DomainObjectPropertyType.ProductOzonArticle]: "ozonArticle",
  [DomainObjectPropertyType.ProductWildberriesArticle]: "wildberriesArticle",
  [DomainObjectPropertyType.ProductSize]: "size",
  [DomainObjectPropertyType.ManufacturersSize]: "size",
};

export const getKeyByDomainObjectPropertyType = (
  from: "partner" | "product" | undefined,
  domainObjectPropertyType: DomainObjectPropertyType,
): string | null => {
  const mappedData =
    from === "partner"
      ? PartnerKeyByDomainObjectPropertyType
      : BaseProductKeyByDomainObjectPropertyType;

  return mappedData[domainObjectPropertyType] || null;
};
